import { PAGE_INFO_TYPE, SUB_PAGE_INFO_TYPE } from "../types/globalConstantsTypes";

type PageListForMenuType = {
  title: string;
  slug: string;
};

const plt_getPageListForMenu = (pathList: string[], pageInfo: PAGE_INFO_TYPE): PageListForMenuType[] => {
  let pageListForMenu: PageListForMenuType[] = [];

  Object.keys(pageInfo).forEach((key) => {
    const isSlugContained = pathList.some(part => part.includes(pageInfo[key].SLUG));

    if (isSlugContained) {
      pageListForMenu.push({ title: pageInfo[key].TITLE, slug: pageInfo[key].SLUG });

      // サブページがあるかどうかチェック
      const subPageInfo: SUB_PAGE_INFO_TYPE | undefined = pageInfo[key]?.SUB;

      if (subPageInfo) {
        const subPageList = Object.values(subPageInfo).map(subPage => ({
          title: subPage.TITLE,
          slug: subPage.SLUG,
        }));

        for (let i = 2; i < pathList.length; i++) {
          const subPathText = pathList.slice(1, i + 1).join("/");

          subPageList.forEach((subPage) => {
            if (subPage.slug == subPathText) {
              pageListForMenu.push({ title: subPage.title, slug: subPage.slug });
            }
          });
        }

      }
    }
  });

  return pageListForMenu;
};

export default plt_getPageListForMenu;
